module.exports = __webpack_public_path__ + "img/vt-03.9834f906.svg";